import { render, staticRenderFns } from "./TranslationUploadBatchConversionModal.vue?vue&type=template&id=63664865"
import script from "./TranslationUploadBatchConversionModal.vue?vue&type=script&lang=js"
export * from "./TranslationUploadBatchConversionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports